module.exports = __webpack_public_path__ + "img/rili.96a2c1b5.png";